export default "/email-attendees-modal.0ecd56e8-676dc0.png";